export function Logo({ compact = false }: { compact?: boolean }) {
  return <div className="brand"><img src="/logo.svg" alt="" /><div><strong>asystowo.pl</strong>{!compact && <span>Twój przegląd rynku</span>}</div></div>;
}
